<template>
  <el-row>
    <el-row :gutter="15">
      <el-col :span="9">
        <el-card
          header="Key Fields"
          shadow="never"
        >
          <PeekKeyFields :account="$props.account" />
        </el-card>
      </el-col>

      <el-col :span="15">
        <el-card
          shadow="never"
          class="mb-3"
        >
          <template #header>
            Events
            <el-button
              type="text"
              @click.native="createEvent"
            >
              New Event
            </el-button>
          </template>
          <Events :account-id="$_.get(account, 'id')" />
        </el-card>
        <el-card shadow="never">
          <div slot="header">
            <span>Notes</span>
            <el-button
              type="text"
              @click.native="() => $refs.notes.create()"
            >
              Add Note
            </el-button>
          </div>
          <Notes
            ref="notes"
            :resource="$props.account"
            truncate
            paginate
            pagination-layout="prev, pager, next"
            :limit="3"
          />
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import PeekKeyFields from '@/components/Application/CustomerService/Accounts/Account/Peek/KeyFields'
import Notes from '@/components/Notes'
import Events from '@/components/Application/Sales/Opportunities/Opportunity/Peek/Events'
import EventFormDialog from '@/components/Application/Sales/Events/Event/CreateDialog'
import Vue from 'vue'

export default {
  components: {
    PeekKeyFields,
    Notes,
    Events
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  methods: {
    createEvent () {
      const EventFormDialogClass = Vue.extend(EventFormDialog)
      const propsData = { event: new this.$sdk.account_event() }
      propsData.event.account = this.account

      propsData.disabledFields = [
        'account'
      ]

      this.eventFormDialogInstance = new EventFormDialogClass({
        propsData
      })

      this
        .eventFormDialogInstance
        .$on('destroy', () => {
          this.eventFormDialogVisible = false
        })

      this
        .eventFormDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.eventFormDialogInstance.$el)

      this.eventFormDialogVisible = true
    }
  }
}
</script>
